import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Popup } from 'semantic-ui-react';


const Bead = (props) => {
    const { beadstate, small, tooltipText, color } = props;

    let beadClassName = classnames({
        "c-bead": true,
        [color] : (color ? true : false)
    });

    let circleClassName = classnames({
        "c-bead__circle": true,        
        "small": small ? true: false
    });

    let innerCicleClassName = classnames({
        "c-bead__circle__inner":true,
        [beadstate] : true
    });

    let iconStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: '#FFF'
    };
    
    let iconClassName = classnames({
        "fa": true,
        "fa-exclamation": (beadstate === "half"),
        "fa-times":(beadstate === "empty"),
        "fa-check": (beadstate === "full")
    });

    const circle = (<div className={circleClassName}>
        <i className={iconClassName} style={iconStyle} />
    </div>);

    return(<div className={beadClassName}>                    
        <Popup trigger={circle} content={tooltipText} />
    </div>);
};

Bead.propTypes = {
    beadstate: PropTypes.string,
    small: PropTypes.bool,
    tooltipText: PropTypes.string,
    color: PropTypes.string
};

export default Bead;